module.exports = __webpack_public_path__ + "img/wyglfw1.22e06e56.png";